import { render } from "./EquipmentBrandModels.vue?vue&type=template&id=2508ca1a"
import script from "./EquipmentBrandModels.vue?vue&type=script&lang=js"
export * from "./EquipmentBrandModels.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./EquipmentBrandModels.vue?vue&type=style&index=0&id=2508ca1a&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script